import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
  Inject,
} from '@angular/core';
import { DragulaService } from 'ng2-dragula';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-drag-n-drop',
  templateUrl: './drag-n-drop.component.html',
  styleUrls: ['./drag-n-drop.component.scss'],
})
export class DragNDropComponent implements OnInit, OnDestroy {
  @Input('answerOptions') answerOptions: string[] | number[] = [];
  @Input('useImages') useImages: boolean = false;
  @Input('question') question: string;
  @Output('rankingChange') rankingChange = new EventEmitter<{
    answers: string[] | number[];
  }>();
  answers: string[] | number[] = [];
  subs = new Subscription();

  // dragula offers easy implementation of drag & drop features
  constructor(
    private dragulaService: DragulaService,
    @Inject('BASE_URL') private baseUrl: string
  ) {}

  ngOnInit(): void {
    this.subs.add(
      this.dragulaService.dropModel(this.question).subscribe((args) => {
        if (args.target.id === 'target-answers') {
          this.rankingChange.emit({ answers: args.targetModel });
        } else if (args.source.id === 'target-answers') {
          this.rankingChange.emit({ answers: args.sourceModel });
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  getImagePath(imageName: string) {
    return `${this.baseUrl}assets/images/${imageName}`;
  }
}
